export function isAutomationMode(): boolean {
  if (typeof window === 'undefined') return false;

  const hasLhciQuery = new URLSearchParams(window.location.search).has('lhci');
  const isHeadless = /HeadlessChrome/i.test(window.navigator.userAgent);
  const isWebdriver = Boolean(window.navigator.webdriver);
  const fromEnv = import.meta.env.VITE_LHCI === '1';

  return hasLhciQuery || isHeadless || isWebdriver || fromEnv;
}